/* eslint-disable import/no-relative-packages */
import type { AppProps } from 'next/app';

import { useMaintenanceMode } from 'config/features';
import CommunicationProvider from 'context/CommunicationContext';
import DataStorageProvider from 'context/DataStorageContext';
import DomainProvider from 'context/DomainContext';
import { NextPage } from 'next';
import Head from 'next/head';
import Maintenance from 'pages/maintenance';
import { ComponentType, ReactElement } from 'react';

// these have to be in this order or it breaks CSS - this needs to be investigated and fixed
import '../styles.css';
import '../node_modules/@collinsonx/design-system/dist/assets/dates.styles.css';
import '../node_modules/@collinsonx/design-system/dist/assets/styles.css';
import '../globalStyles.css';

type Page<P = object> = {
  getLayout?: (page: ReactElement) => JSX.Element;
  layout?: ComponentType;
} & NextPage<P>;

type Props = {
  Component: Page;
} & AppProps;

export default function MyApp({ Component, pageProps }: Props) {
  // Use the layout defined at the page level, if available
  const getLayout = Component.getLayout ?? ((page) => page);

  return (
    <>
      <Head>
        <title>Booking</title>
        <meta
          content="minimum-scale=1, initial-scale=1, width=device-width"
          name="viewport"
        />
      </Head>

      <DataStorageProvider>
        <DomainProvider pageProps={pageProps}>
          <CommunicationProvider>
            {getLayout(
              useMaintenanceMode ? (
                <Maintenance />
              ) : (
                <Component {...pageProps} />
              )
            )}
          </CommunicationProvider>
        </DomainProvider>
      </DataStorageProvider>
    </>
  );
}
